import { gql } from "graphql-request";
import { IMAGE_FRAGMENT } from "./fragments";

/**
 * Contains queries for fetching the latest news, news labels, and hotel image data.
 * Used across homepage and news listing sections.
 */

// Fetches latest news items with associated metadata and featured images
export const LATEST_NEWS = gql`
  ${IMAGE_FRAGMENT}
  query latestNews(
    $locale: I18NLocaleCode
    $sort: [String]
    $pagination: PaginationArg
    $status: PublicationStatus
    $filters: NewsYearMonthDayItemFiltersInput
  ) {
    newsYearMonthDayItems(
      locale: $locale
      sort: $sort
      pagination: $pagination
      status: $status
      filters: $filters
    ) {
      item_name
      documentId
      properties {
        category_type
        content
        header_title
        sub_header_title
        hide_contact_section
        featured_image {
          ...ImageUrlProperties
        }
        date_created
        external_link
        use_featured_Image
        hotel_names
      }
      tags {
        related_hotels
      }
    }
  }
`;

// Retrieves label text and configuration for the Latest News section
export const LATEST_NEWS_LABEL = gql`
  query latestNewsLabel($locale: I18NLocaleCode, $status: PublicationStatus) {
    sharedDatasourcesReusableLatestNewsDatasources(
      locale: $locale
      status: $status
    ) {
      display_name
      header
      press_release_label
      company_news_label
      button_text
      button_link
      show_in_section
    }
    homeDatasourcesLatestNewsDatasources {
      group_news
      hotel_news
    }
  }
`;

// Fetches hotel image data for sliders (desktop and custom sources)
export const GET_HOTEL_IMAGE_NEW = gql`
  query GetHotelImageNew(
    $locale: I18NLocaleCode
    $status: PublicationStatus
    $filters: JapanHotelFiltersInput
  ) {
    japanHotels(locale: $locale, status: $status, filters: $filters) {
      documentId
      item_name
      hotel_images {
        slider_desktop(pagination: { limit: -1 }) {
          documentId
          image_url {
            documentId
            cloudflare_url
            url
          }
        }
      }
      datasources {
        slider_datasources {
          documentId
          display_name
          item_name
          information {
            picked_images_desktop
          }
        }
      }
    }
  }
`;
